<script setup>
const props = defineProps({
  item: Object,
})

const alignmentStyle = computed(() => ({
  objectPosition: props.item.properties.alignment?.replace('_', ' '),
}))
</script>

<template>
  <img class="absolute top-0 left-0 w-full h-full object-contain bg-black" :style="alignmentStyle" :src="item.properties.image" />
</template>
